module.exports = __webpack_public_path__ + "img/Worth_School.7475f47a.jpg";